module.exports = __webpack_public_path__ + "dc866fbeb0f4ee69c09687c9b4e6a19a.pdf";